import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const ReactSelect = (props) => {

    return (
    <div>
        <Select
            {...props}
            value={props.input.value}
            options={props.options}
            onChange={(val) => props.input.onChange(val.value)}
            multi={false}
            clearable={false}
            onBlur={() => props.input.onBlur(props.input.value)}
        />
        {props.meta.touched && (props.meta.error &&
        <div className="form-control-feedback error-block" style={{color: "#e9595b"}}>{props.meta.error}</div>)}
    </div>
    );

};

export default ReactSelect;


// WEBPACK FOOTER //
// ./web/src/components/common/ReactSelect.jsx